import { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { API_URL, authFetch } from "../../utils/auth";
import ClientProjectDetail from "../../clients/projects/ClientProjectDetail";
import StaffProjectWorkspace from "../../staff/StaffProjectWorkspace";

export default function ProjectDetailPage() {
  const role = localStorage.getItem("portal_role") || "client";
  const isSuperuser = localStorage.getItem("is_superuser") === "true";
  const isInternal = localStorage.getItem("is_internal") === "true" || isSuperuser;
  const isPartner = role === "partner";
  const { id } = useParams();
  const [project, setProject] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const loadProject = useCallback(async () => {
    setLoading(true);
    try {
      const response = await authFetch(`${API_URL}/client/projects/${id}/`);
      const data = await response.json();
      if (!response.ok) throw new Error(data.detail || "Unable to load project.");
      setProject(data);
      setError("");
    } catch (err) {
      console.error(err);
      setError(err.message || "Unable to load project.");
    } finally {
      setLoading(false);
    }
  }, [id]);

  useEffect(() => { if (!isInternal || isPartner) loadProject(); }, [loadProject, isInternal, isPartner]);

  if (isInternal && !isPartner) return <StaffProjectWorkspace />;

  return <ClientProjectDetail project={project} loading={loading} error={error} onRefresh={loadProject} />;
}